import { useQuery } from '@apollo/client'

import subnetApiLogsGql from 'gql/subnetApiLog/subnetApiLogs.gql'
import allApiLogsGql from 'gql/subnetApiLog/allApiLogs.gql'

export interface SubnetApiLog {
  id: string
  subnet_api_service_id: string
  request_url: string
  request_method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH' | 'HEAD' | 'OPTIONS'
  request_headers: any
  request_body: any
  response_status: number
  response_headers: any
  response_body: any
  response_duration: number
  error_message: string
  error_code?: number
  request_id: string
  consumer_id: string
  account_id: string
  created_on: Date
  service_name: string
  subnet_name: string
  service_icon: string
}

export interface UseSubnetApiLog {
  data: {
    items: SubnetApiLog[]
    total_count: number
  }
  error: any
  loading: boolean
  refetch: ({ url, subnet_id }: { url: string; subnet_id: string | undefined }) => void
}

export const useSubnetApiLog = (subnet_id: string | undefined, url: string): UseSubnetApiLog => {
  const { data, error, loading, refetch } = useQuery(subnetApiLogsGql, {
    skip: !url,
    fetchPolicy: 'cache-and-network',
    variables: { subnet_id, url },
  })

  return {
    data: data?.subnetApiLogs || { items: [], total_count: 0 },
    error,
    loading,
    refetch,
  }
}

export const useAllApiLogs = (url: string): UseSubnetApiLog => {
  const { data, error, loading, refetch } = useQuery(allApiLogsGql, {
    skip: !url,
    fetchPolicy: 'cache-and-network',
    variables: { url },
  })

  return {
    data: data?.allApiLogs || { items: [], total_count: 0 },
    error,
    loading,
    refetch,
  }
}
